<div class="filter-more-item">
  <label class="upper-label" (click)="mySelect.open()">Baths</label>

  <div class="inline-grid gap-x-3 grid-cols-2 w-full">
    <div class="label label-col2">
      <app-shared-input label="Min" [selector]="true" [value]="minValue">
        <mat-select
          #mySelect
          (selectionChange)="handleChange()"
          [(ngModel)]="minValue"
          [ngClass]="{
            'select-placeholder': minValue === 0
          }"
        >
          <mat-option [value]="0">No min</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="1.5">1.5</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="5">5</mat-option>
        </mat-select>
      </app-shared-input>
    </div>

    <div class="label label-col2">
      <app-shared-input label="Max" [selector]="true" [value]="maxValue">
        <mat-select
          (selectionChange)="handleChange()"
          [(ngModel)]="maxValue"
          [ngClass]="{
            'select-placeholder': maxValue === 0
          }"
        >
          <mat-option [value]="0">No max</mat-option>
          <mat-option [value]="1" *ngIf="minValue <= 1">1</mat-option>
          <mat-option [value]="1.5" *ngIf="minValue <= 1.5">1.5</mat-option>
          <mat-option [value]="2" *ngIf="minValue <= 2">2</mat-option>
          <mat-option [value]="3" *ngIf="minValue <= 3">3</mat-option>
          <mat-option [value]="4" *ngIf="minValue <= 4">4</mat-option>
          <mat-option [value]="5" *ngIf="minValue <= 5">5</mat-option>
        </mat-select>
      </app-shared-input>
    </div>
  </div>
</div>
